import {
  HalfHourlyConsumptionTariffs,
  HalfHourlyData,
  HalfHourlyIncrement,
} from "@givenergy/sales-simple-energy-comparison";
import { HouseholdInformationData } from "@components/forms/household-information/types.ts";

export type OnlyOfType<T extends object, ValueType> = {
  [K in keyof T as T[K] extends ValueType ? K : never]: T[K];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ObjectLeaves<O, T = any> = O extends object
  ? {
      [K in keyof OnlyOfType<
        O,
        T
      >]: `${Exclude<K, symbol>}${ObjectLeaves<O[K], T> extends never ? "" : `.${ObjectLeaves<O[K], T>}`}`;
    }[keyof OnlyOfType<O, T>]
  : never;

export type Required<T> = { [K in keyof T]: NonNullable<T[K]> };
export type Nullable<T> = { [K in keyof T]: T[K] | null };
export type Optional<T> = { [K in keyof T]: T[K] | undefined };

export type TariffPoint = {
  from: HalfHourlyIncrement;
  to: HalfHourlyIncrement;
  price: number;
};

export type OptionalHalfHourlyTariff = Optional<HalfHourlyData> & {
  type: HalfHourlyConsumptionTariffs["type"];
};

export const isFullHalfHourlyTariff = (
  tariff: OptionalHalfHourlyTariff,
): tariff is HalfHourlyConsumptionTariffs => {
  return (
    tariff.type === "tariff" &&
    Object.values(tariff).every((value) => value !== undefined)
  );
};

export const isFullGridKwh = (
  gridKwh: HouseholdInformationData["gridKwh"],
): gridKwh is Required<HouseholdInformationData["gridKwh"]> => {
  return gridKwh.import !== null && gridKwh.export !== null;
};
